import { offerDashboardConstants } from "../../../../constants/Offer/offerDashboard.constants";

const initialState = {
    fetching :false,
    offerData: [],
    error    :{},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case offerDashboardConstants.GET_OFFER_DASHBOARD_PENDING:
            return {
                ...state,
                fetching:true
            };
        case offerDashboardConstants.GET_OFFER_DASHBOARD_FULFILLED:
            return {
                ...state,
                fetching : false,
                offerData: action.payload,
            };
        case offerDashboardConstants.GET_OFFER_DASHBOARD_FAILURE:
            return {
                ...state,
                fetching : false,
            }
        default:
            return state
    }
}
